import { components } from 'type/ReportServiceSchema';

export type DepartmentDto = components['schemas']['DepartmentDTO2'];

export type DepartmentModel = {
  id: number;
  title: string;
  path: string[];
  description: string;
};

export const mapDepartmentDtoToModel = (dto: DepartmentDto): DepartmentModel => dto;
